import React from "react";

function CallbackApple() {
  return <div> CALLBACK APPLE!</div>;
}
export default CallbackApple;
